// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialClient = () => {
  let item = window.localStorage.getItem('client')

  while (item === undefined) {
    item = window.localStorage.getItem('client')
  }

  return item ? JSON.parse(item) : undefined
}

export const clientSlice = createSlice({
  name: 'client',
  initialState: {
    clientData: initialClient()
  },
  reducers: {
    setClient: (state, action) => {
      state.clientData = action.payload
      localStorage.setItem('client', JSON.stringify(action.payload))
    },
    loadClient: (state, action) => {
      state.clientData = action.payload
    }
  }
})

export const { setClient, loadClient } = clientSlice.actions


 //function getClient(url) {
//  return url.substring(0, url.indexOf('.'))
//}

//function getEnv(url) {
//  const temp = url.replace(`${getClient(url)}.`, '')
//  return temp.substring(0, temp.indexOf('.'))
//}

export const fetchClient = () => (dispatch) => {
  const existing = initialClient()
  if (existing) {
    // Load existing data into Redux without overwriting localStorage
    dispatch(loadClient(existing))
  } else {
    dispatch(setClient({name: 'Optima HR', shortname: 'Optima HR'}))
  }
}

export default clientSlice.reducer
